import type CrudAction from '@/features/crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const FacebookPage = async () => import('@/pages/FacebookPage.vue');
const FacebookAccountFormModal = async () =>
  import('@/features/facebook/facebook-account-form-modal/FacebookAccountFormModal.vue');
const FacebookProxiesListModal = async () =>
  import('@/features/facebook/proxies/proxies-list-modal/FacebookProxiesListModal.vue');
const FacebookProxyFormModal = async () =>
  import('@/features/facebook/proxies/proxy-form-modal/FacebookProxyFormModal.vue');

type FormModalPageProps = {
  action: CrudAction;
};

export function getFacebookRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'facebook',
      children: [
        {
          name: 'create-facebook-account',
          component: FacebookAccountFormModal,
          path: '/facebook/accounts/create',
          props: (): FormModalPageProps => ({
            action: {
              type: CrudActionType.CREATE,
            },
          }),
        },
        {
          name: 'edit-facebook-account',
          component: FacebookAccountFormModal,
          path: '/facebook/accounts/edit/:id',
          props: (route): FormModalPageProps => ({
            action: {
              id: route.params.id as string,
              type: CrudActionType.EDIT,
            },
          }),
        },
        {
          name: 'clone-facebook-account',
          component: FacebookAccountFormModal,
          path: '/facebook/accounts/clone/:id',
          props: (route): FormModalPageProps => ({
            action: {
              id: route.params.id as string,
              type: CrudActionType.CLONE,
            },
          }),
        },
        {
          name: 'facebook-proxies',
          children: [
            {
              name: 'create-facebook-proxy',
              component: FacebookProxyFormModal,
              path: '/facebook/proxies/create',
              props: (): FormModalPageProps => ({
                action: {
                  type: CrudActionType.CREATE,
                },
              }),
            },
            {
              name: 'edit-facebook-proxy',
              component: FacebookProxyFormModal,
              path: '/facebook/proxies/edit/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.EDIT,
                },
              }),
            },
            {
              name: 'clone-facebook-proxy',
              component: FacebookProxyFormModal,
              path: '/facebook/proxies/clone/:id',
              props: (route): FormModalPageProps => ({
                action: {
                  id: route.params.id as string,
                  type: CrudActionType.CLONE,
                },
              }),
            },
          ],
          component: FacebookProxiesListModal,
          path: '/facebook/proxies',
        },
      ],
      component: FacebookPage,
      meta: {
        title: 'Facebook',
        useIn: ['navigation-tabs'],
      },
      path: '/facebook',
    },
  ];
}
